<!--
 * @Author: your name
 * @Date: 2022-03-04 13:36:36
 * @LastEditTime: 2022-03-04 17:37:50
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\components\pageComponents\scrollHead.vue
-->
<template>
  <div class="drop_header_content" v-if="isShowDropHeader">
    <div class="drop_hearder_div" >
      <div class="drop_header_div_02">
        <category-list />
        <search-com />
        <simple-cart leftValue="0"/>
      </div>
    </div>
  </div>
</template>
<script>
import SimpleCart from '../cart/SimpleCart.vue';
import categoryList from './categoryList.vue';
import searchCom from './searchCom.vue'
export default {
  components: { SimpleCart,categoryList,searchCom},
  data() {
    return {
      isInsertSearchRecord: false,
      isShowDropHeader:false,
    };
  },
  props: {
    queryParams: {
        type: Object,
        default: function () {
            return {}
        }
    }
  },
  methods: {},
};
</script>
<style scoped>
.drop_header_content{
  width:100%;
  box-shadow: 0 0 10px 0px #eeeeee;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.drop_hearder_div{
  width:100%;
  background-color:rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.drop_header_div_02{
  width: 1200px;
  height: 72px;
  display: inline-block;
  display:flex;
  justify-content: space-between;
  align-items:center;
}
</style>




// WEBPACK FOOTER //
// src/components/pageComponents/scrollHead.vue